import {type TranslationObject} from '@colonist/i18n'
import {type SocketDataTypes} from '../../../../shared/SocketDataTypes.ts'
import {type LobbyImage} from '@colonist/types'
import {type NotificationContentType} from '../ui_utils/NotificationUtils.ts'

export enum UITopNotificationType {
    Information,
    Success,
    Warning,
    Error,
    SocketError,
    Reconnect,
}

export abstract class UINotificationController {
    abstract show(text: TranslationObject, type: UITopNotificationType, buttonText?: TranslationObject, action?: () => void, removeAction?: () => void, showCloseButton?: boolean, duration?: number)

    abstract showNotification(icon: LobbyImage, text: TranslationObject, duration?: number, action?: () => void, removeAction?: () => void, contentType?: NotificationContentType)

    abstract showGames(games: SocketDataTypes.UserGamesData[])

    abstract removeDisconnectBanners()

    abstract removeSocketErrorBanners()
}
